import React, { useEffect } from 'react';
import { useHistory } from 'react-router-dom';
import Loader from '@tcl-boron-prefabs/loader';
import cn from 'classnames';
import withStyles from '@tempus/component-library/utils/withStyles';
import styles from '../../styles';
import qs from 'query-string';
import { handleEhrCodeExchange, isValidEHRQueryParams } from '../../utils/ehr-launch-utils';

function EhrCallBack({ classes }) {
  const history = useHistory();

  useEffect(() => {
    async function getRedirectUrl() {
      const query = qs.parse(window.location.search);
      if (isValidEHRQueryParams(query)) {
        const redirect = await handleEhrCodeExchange(query.code);
        if (redirect) {
          history.push({
            pathname: '/',
            search: `?redirect=${redirect}`,
          });
        }
      }
    }
    getRedirectUrl();
  }, []); // eslint-disable-line

  return (
    <div className={cn('app-view-container', classes.loadingContainer)}>
      <Loader />
    </div>
  );
}

export default withStyles(styles)(EhrCallBack);
